import { render, staticRenderFns } from "./CollapseItemCard.vue?vue&type=template&id=e6a23034&scoped=true"
import script from "./CollapseItemCard.vue?vue&type=script&lang=js"
export * from "./CollapseItemCard.vue?vue&type=script&lang=js"
import style0 from "./CollapseItemCard.vue?vue&type=style&index=0&id=e6a23034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a23034",
  null
  
)

export default component.exports